// @flow

import * as React from 'react';

import { View } from 'reshaped';

import { useAppSelector } from 'src/hooks';
import { selectShopCurrent } from 'src/modules/organization/selectors';

import { ContactForm } from '../ContactForm';

import { Header } from './Header';

/** AccountCreate
 *  should serve for the first purshase flow
 *  it should read the current orga
 *  fill the form
 *  submit a PUSH to create the orga
 */
export function AccountCreate(): React.MixedElement {
  const current = useAppSelector(selectShopCurrent);

  return (
    <View gap={7}>
      <View.Item>
        <Header />
      </View.Item>
      <View.Item>
        <ContactForm contact={current} firstBuy />
      </View.Item>
    </View>
  );
}
